export default __webpack_public_path__ + "static/media/icon-status-done.aa0cf75e.svg";